import { Phone, PhoneCall, PhoneMissed, X } from 'lucide-react'

// call_result → icon / Thai label / tone. This map existed in RecallPopup.jsx and
// CallList.jsx with DIFFERENT WORDING before a third surface needed it, so it lives
// here now. (Recall.jsx's <CallCell> still has its own variant — รับสาย/ไม่รับสาย/
// สายไม่ว่าง/ต่อไม่ติด — which is a different vocabulary Ram may or may not want
// unified; left alone rather than silently changed.)
export const CALL_ICON = { missed: PhoneMissed, answered: PhoneCall, cancelled: X, failed: Phone }
export const CALL_LABEL = { missed: 'ไม่ได้รับ', answered: 'รับสาย', cancelled: 'ยกเลิก', failed: 'ล้มเหลว' }
export const CALL_TONE = {
  missed:    'text-rose-600',
  answered:  'text-emerald-600',
  cancelled: 'text-slate-400',
  failed:    'text-amber-600',
}

// Recordings exist ONLY for answered calls — the payload's voice.* fields are often
// empty even when one exists, so `answered` is the reliable signal.
export const canListen = (c) => c?.call_result === 'answered'

/**
 * Does a `call_update` announcement concern this patient's call history?
 * Two sources share the channel (checked 2026-10-30):
 *   trigger 15, a NEW call     {type:'new', id, patient_id}  — patient_id since 2026-10-30;
 *                              0 = a call matched to no patient (never in anyone's list)
 *   PATCH /phone/{id} (api 467) {type:'update', id, employee_id} — no patient_id
 * No patient_id at all → yes (an edit, an older trigger): re-reading is the safe side.
 */
export function callEventConcerns(msg, patientId) {
  const p = msg?.payload?.data ?? msg?.payload
  const pid = p && typeof p === 'object' ? p.patient_id : undefined
  return pid == null || (patientId != null && String(pid) === String(patientId))
}
